import React, { Component } from 'react'
export default class Partner extends Component {
  constructor(props) {
    super(props)
    this.state = {
      block: [
        {
          title: 'Baker Tilly International（BTI）',
          content: 'Baker Tilly International（BTI）成立于 1988 年，是全球前十大会计网络，总部位于英国伦敦，在全球拥有122 家成员所，742 家办事处，36332 名员工，业务范围覆盖146 个国家，为客户提供会计、审计、咨询、税务等财务综合性服务，2019 年全球营收总额达39 亿美元。作为体系庞大的会计网络，为给客户提供高质量、本土化的服务，BTI 建立了完备的管理制度和准则要求，并成立了行业审计委员会、国际税务委员会、国际并购委员会，协调各成员所各行业领域专家，可以根据客户需求，打造跨境专业服务团队，将高质量的服务和本地监管要求相结合，整合专家与知识资源，为客户提供卓越和优质的跨境服务。',
          imgPath: require('img/ecology/partner-pic2.png'),
          imgHDPath: `${require('img/ecology/partner-pic2.png')} 1x,${require('img/ecology/partner-pic2@2x.png')} 2x,${require('img/ecology/partner-pic2@3x.png')} 3x`,
          attachURL: '/'
        }
        // {
        //   title: 'RICS皇家特许测量师学会',
        //   content: 'RICS皇家特许测量师学会，是为全球广泛、一致认可的专业性学会，其专业领域涵盖了土地、物业、建造及环境等17 个不同的行业。迄今为止，RICS皇家特许测量师学会已经有140 余年的历史，有14 万多会员分布在全球146 个国家；拥有400 多个RICS 认可的相关大学学位专业课程，每年发表超过500 多份研究及公共政策评论报告，向会员提供覆盖17 个专业领域和相关行业的最新发展趋势；RICS皇家特许测量师学会得到了全球50 多个地方性协会及联合团体的大力支持。',
        //   imgPath: require('img/ecology/partner-rics.png'),
        //   imgHDPath: `${require('img/ecology/partner-rics.png')} 1x,${require('img/ecology/partner-rics@2x.png')} 2x,${require('img/ecology/partner-rics@3x.png')} 3x`,
        //   attachURL: '/'
        // },
        // {
        //   title: '中国工商银行',
        //   content: '中国工商银行，成立于1984 年1 月1 日，是中国最大的商业银行之一，也是世界五百强企业之一，2020 年，荣获全球银行最具品牌价值第一名。中国工商银行在中国及全球28 个国家拥有服务网络，约1.7 万家境内外分支机构，拥有员工385609 人，向全球700 多万公司客户和6 亿多个人客户提供全面的金融产品和服务。中国工商银行始终聚焦主业，坚持服务实体经济本源，与实体经济共荣共存、共担风雨、共同成长；始终坚持风险为本，牢牢守住底线，不断提高控制和化解风险能力；始终坚持对商业银行经营规律的把握与遵循，致力于打造“百年老店”；始终坚持稳中求进、创新求进，持续深化大零售、大资管、大投行以及国际化和综合化战略，积极拥抱互联网；始终坚持专业专注，开拓专业化经营模式，锻造“大行工匠”。',
        //   imgPath: require('img/ecology/partner-zzgsyh.png'),
        //   imgHDPath: `${require('img/ecology/partner-zzgsyh.png')} 1x,${require('img/ecology/partner-zzgsyh@2x.png')} 2x,${require('img/ecology/partner-zzgsyh@3x.png')} 3x`,
        //   attachURL: '/'
        // },
        // {
        //   title: '中国建筑标准设计研究院有限公司',
        //   content: '中国建筑标准设计研究院有限公司，创建于1956 年，前身为建设部直属事业单位⸺建筑标准设计研究所，2000 年转制为中央科技型企业；是综合型科研、设计与技术服务企业，是国家级高新技术企业，隶属中国建设科技集团。公司主要有建筑标准与标准设计、城乡规划、建筑工程设计、工程总承包、技术咨询和产品制造安装等多元业务。',
        //   imgPath: require('img/ecology/partner-yjy.png'),
        //   imgHDPath: `${require('img/ecology/partner-yjy.png')} 1x,${require('img/ecology/partner-yjy@2x.png')} 2x,${require('img/ecology/partner-yjy@3x.png')} 3x`,
        //   attachURL: '/'
        // }
        // {
        //   title: '北京天职税务师事务所有限公司',
        //   content: '简称“天职税务”，前身为天职国际会计师事务所有限公司税务部，是一家专注于公司税务鉴证、财税咨询与培训的专业公司，拥有北京注册税务师协会授予的 4A 级税务师事务所资格，可从事全国范围内的税务鉴证、税务咨询、税务筹划业务。',
        //   imgPath: require('img/ecology/partner-pic2.png'), imgHDPath: `${require("img/ecology/partner-pic2.png")} 1x,${require("img/ecology/partner-pic2@2x.png")} 2x,${require("img/ecology/partner-pic2@3x.png")} 3x`, attachURL: "/"
        // },
        // {
        //   title: '沃克森（北京）国际资产评估有限公司',
        //   content: '简称“沃克森”，是一家专注于资产评估、企业估值的专业公司，可从事证券、期货相关业务资产评估、企业整体资产评估、单项资产评估以及在全国范围内从事土地评估业务，是我国首批取得证券、期货相关业务评估资格的资产评估机构之一。',
        //   imgPath: require('img/ecology/partner-pic3.png'), imgHDPath: `${require("img/ecology/partner-pic3.png")} 1x,${require("img/ecology/partner-pic3@2x.png")} 2x,${require("img/ecology/partner-pic3@3x.png")} 3x`, attachURL: "/"
        // },
        // {
        //   title: '北京华鼎方略国际咨询有限公司',
        //   content: '简称“华鼎方略”，前身是天职国际管理咨询部。华鼎方略咨询公司提供内控与风险管理咨询、财务咨询、IT 咨询等咨询服务，涉及的行业领域包括能源、通信媒体、房地产、金融服务、生产制造等。',
        //   imgPath: require('img/ecology/partner-pic1.png'), imgHDPath: `${require("img/ecology/partner-pic1.png")} 1x,${require("img/ecology/partner-pic1@2x.png")} 2x,${require("img/ecology/partner-pic1@3x.png")} 3x`, attachURL: "/"
        // },
      ]
    }
  }
  render() {
    return (
      <div className="partner-container">
        <p className="ecology-title">战略合作伙伴</p>
        {this.state.block.map((item, index) => (
          <article className="partner-block" key={index}>
            {item.imgPath && <img src={item.imgPath} alt="" srcSet={item.imgHDPath} className="sub-img" />}
            <p className="sub-title">{item.title}</p>
            <div className="sub-box" dangerouslySetInnerHTML={{ __html: item.content }} />
          </article>
        ))}
      </div>
    )
  }
}
